import { render } from "./TabContacts.vue?vue&type=template&id=259e0986&scoped=true"
import script from "./TabContacts.vue?vue&type=script&lang=js"
export * from "./TabContacts.vue?vue&type=script&lang=js"

import "./TabContacts.vue?vue&type=style&index=0&id=259e0986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259e0986"]])

export default __exports__